import { collectArrayFromAttributes } from '../attributes'
import { SkipperLinkAttributes, SkipperLinkVirtualQuestion } from '../types'

export function skipperLinkVirtualQuestionAttributesFinalize(attributes: SkipperLinkAttributes) {
  attributes.questionType = 'vq'
  attributes.title ??= '(show)'
  attributes.qtitle ??= 'Virtual Question'
  return attributes
}

export function skipperLinkAttributesToVirtualQuestion(attributes: SkipperLinkAttributes): SkipperLinkVirtualQuestion {
  const question: SkipperLinkVirtualQuestion = {
    text: attributes.qtitle,
    type: 'dlv',
    variant: 'rb' === attributes.variant ? 'rb' : 'cb',
    answerVariants: collectArrayFromAttributes(
      attributes,
      'a',
      ['text', 'pattern', 'other', 'base'],
      ['text', 'pattern']
    ).map((attribute, index) => {
      const vqAnswerVariant: SkipperLinkVirtualQuestion['answerVariants'][0] = {
        text: attribute.text,
        pattern: attribute.pattern,
        position: index + 1,
        options: { mode: 'basic' }
      }
      if (attribute.base) {
        vqAnswerVariant.base = attribute.base
      }
      if ('true' === attribute.other) {
        vqAnswerVariant.other = true
      }
      return vqAnswerVariant
    })
  }
  return question
}
